import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateAppForm } from '~/components/forms/AppForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type ICreateAppPageProps = {
  organizationId?: string;
};

export const CreateAppPage: React.FC<ICreateAppPageProps> = (props) => {
  const { organizationId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const previousUrl = organizationId
    ? `/organizations/${organizationId}`
    : '/apps';

  return (
    <>
      <Helmet>
        <title>{t('CreateAppPage.seo.title')}</title>
      </Helmet>

      <Heading title={t('CreateAppPage.title')} previousUrl={previousUrl} />

      <CreateAppForm
        organizationId={organizationId}
        onSuccess={(createdApp) => navigate(`/apps/${createdApp._id}`)}
        cancelUrl={previousUrl}
      />
    </>
  );
};
